/**
 * Resolve an origin-free Supabase Storage path to an absolute URL.
 *
 * The DB stores image URLs without an origin, e.g.
 *   `/storage/v1/object/public/<bucket>/<path>`
 * The custom next/image loader (lib/image-loader.ts) re-attaches the origin at
 * render time, so anything rendered through next/image works with the relative
 * path as-is.
 *
 * This helper covers the places that DON'T go through that loader and therefore
 * REQUIRE an absolute URL:
 *   - raw `<img>` / `background-image` / `new Image()`
 *   - route metadata (openGraph / twitter images)
 *   - JSON-LD structured data (schema.org image)
 *
 * Behavior:
 *   - value starting with `/storage/v1/` → prefixed with NEXT_PUBLIC_SUPABASE_URL
 *     (trailing slash trimmed)
 *   - anything else (already absolute, local `/public` asset, null) → returned as is
 */
export function resolveStorageUrl(url: string): string;
export function resolveStorageUrl(url: null | undefined): null;
export function resolveStorageUrl(url: string | null | undefined): string | null;
export function resolveStorageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('/storage/v1/')) {
    const base = process.env.NEXT_PUBLIC_SUPABASE_URL?.replace(/\/$/, '');
    if (base) return base + url;
  }
  return url;
}
